import type { LivevxLocale } from "@/locales/fr/livevx";

import {
  EExaLightIsAutoTest,
  EExaLightModulationMode,
  EExaLightModulationOrigin,
  EExaLightRelayState,
} from "@/types/backoffice/dto/odity-extended/odity-extended-modulator-exact-dto.ts";

const modulationMode: Record<EExaLightModulationMode, string> = {
  [EExaLightModulationMode.COMFORT_PASS_THROUGH]: "Copie du signal entrant / confort",
  [EExaLightModulationMode.STOP]: "Stop",
  [EExaLightModulationMode.FROST_GUARD]: "Frost Guard",
  [EExaLightModulationMode.ECO]: "Eco",
  [EExaLightModulationMode.COMFORT]: "Comfort",
  [EExaLightModulationMode.COMFORT_1]: "Comfort -1°C",
  [EExaLightModulationMode.COMFORT_2]: "Comfort -2°C",
  [EExaLightModulationMode.NO_MODULATION]: "No active modulation",
  [EExaLightModulationMode.FAILED_BACKEND]: "Server Internal Error",
  [EExaLightModulationMode.ON]: "On",
  [EExaLightModulationMode.TEMPERATURE]: "Temperature",
};

const livevxLocale: LivevxLocale = {
  livevx: {
    realtimeControlMonitoring: "Real time Control Monitoring",
    title: "Real Time",
    isProcessing: "Processing",
    stopped: "Stopped",
    roomChoice: "Choose a room",
    audit: "Refresh",
    timeSlotFrom: "Time slot from",
    timeSlotTo: "to",
    resultModulation: "Modulation results :",
    noModulation: "No modulation",
    noConsoleDiag: "No diagnostic response from modulator",
    modulationProcessing: "Modulation processing :",
    originModulation: "Origin :",
    relayState: "Relay :",
    wireCommandMode: "Wire Pooling :",
    autoTesting: "Test auto processing :",
    resultPower: "Active power results :",
    measuredPower: "Active power value :",
    noMeasures: "No power data",
    relay: {
      [EExaLightRelayState.OPEN]: "Open",
      [EExaLightRelayState.CLOSED]: "Close",
      [EExaLightRelayState.UNKNOWN]: "Error",
      [EExaLightRelayState.IS_NOT_A_RELAY]: "Error",
    },
    autoTestingState: {
      [EExaLightIsAutoTest.TRUE]: "Yes",
      [EExaLightIsAutoTest.FALSE]: "No",
      [EExaLightIsAutoTest.NO_INFO]: "Error",
    },
    modulationOrigin: {
      [EExaLightModulationOrigin.UNKNOWN]: "Unknown origin",
      [EExaLightModulationOrigin.PRODUCTION]: "Voltalis Modulation",
      [EExaLightModulationOrigin.SSY]: "Voltalis Modulation (Service System)",
      [EExaLightModulationOrigin.SUBSCRIBER_TEMPERATURE]: "Control by température",
      [EExaLightModulationOrigin.SUBSCRIBER_ON_OFF]: "Heating Program ON/OFF",
      [EExaLightModulationOrigin.SUBSCRIBER_ABSENCE]: "Manual Control or Quick Mode",
      [EExaLightModulationOrigin.SUBSCRIBER_HEATER]: "Weekly Heating mode",
      [EExaLightModulationOrigin.FAILED_BACKEND]: "Error Server",
    },
    modulationMode,
    history: {
      title: "History",
      power: "Consumption: {power} W",
      weekly: "Weekly: {isWeekly}",
      yes: "Yes",
      no: "No",
      mode: "Mode:",
      start: "Start: {start}",
      end: "End: {end}",
    },
    exactModulationMode: {
      [EExaLightModulationMode.ON]: "On",
      [EExaLightModulationMode.STOP]: "Stop",
      [EExaLightModulationMode.ECO]: "Eco",
      [EExaLightModulationMode.FROST_GUARD]: "Frost-guard",
      [EExaLightModulationMode.COMFORT]: "Comfort",
      [EExaLightModulationMode.COMFORT_PASS_THROUGH]: "Comfort pass through",
      [EExaLightModulationMode.TEMPERATURE]: "Temperature",
    },
  },
};

export default livevxLocale;
